import React from "react";
import { PostLogin } from "../component/Header";
import AssignmentRules from "./AssignmentRules";
import { PERMISSION_KEY } from "../types/Rbac/permission";
import { useRequireRBAC } from "../component/shared/useRequireRBAC";

function AssignmentRulesContainer() {
  useRequireRBAC([PERMISSION_KEY.automationView]);

  return (
    <div className={`post-login`}>
      <PostLogin selectedItem={"Assignment"} />
      <AssignmentRules />
    </div>
  );
}

export default AssignmentRulesContainer;
